module.exports = __webpack_public_path__ + "img/edit_white.868f2c91.svg";